<template>
  <div id="wrapper">
    <div class="contactUS-info">
      <div class="website">
        <b>米兔网络科技官网</b>
        <span>www.xiaobaiqianbao.com</span>
      </div>
      <div class="contact">
        <div class="contact-unit">
          <img src="../../static/images/home/contactUS-2.png">
          <div>
            <div>客服微信号 </div>
            <div>xiaobaibao05</div>
          </div>
        </div>
        <div class="contact-unit">
          <img src="../../static/images/home/contactUS-3.png">
          <div>
            <div>联系电话 </div>
            <div>020-82526981</div>
          </div>
        </div>
        <div class="contact-unit">
          <img src="../../static/images/home/contactUS-4.png">
          <div>
            <div>邮箱地址 </div>
            <div>kf@xiaobiaobao.com</div>
          </div>
        </div>
        <div class="contact-unit">
          <img src="../../static/images/home/contactUS-5.png">
          <div>
            <div>地址 </div>
            <div>广州市越秀区解放南路39号万菱广场15层1506房</div>
          </div>
        </div>
      </div>
    </div>
    <div class="contactUS">
      <div class="contactUS-map"></div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "contactUS",
      data() {
        return {
        }
      },
      methods: {

      },
      mounted() {

      }
    }
</script>

<style scoped>
  .contactUS-info{
    width: 100%;
    padding: 8rem 15% 5rem;
  }

  .contactUS-info .website>b{
    font-size: 1.5rem;
    color: #F47423;
    margin-right: 1.5rem;
  }
  .contactUS-info .website>span{
    font-size: 1rem;
    color: #666666;
    font-weight: bold;
  }

  .contact{
    width: 100%;
    color: #666666;
    font-size: 1rem;
    font-weight: bold;
    text-align: left;
    margin: 0 auto;
    padding: 3rem 0 0;
  }
  .contact-unit{
    width: auto;
    margin: 2rem 2rem 0 0;
    padding: 1rem 1rem 1rem .5rem;
    display: inline-block;
    vertical-align: middle;
    background: #FFF5EF;
  }
  .contact-unit img{
    width: 3.75rem;
    height: 3.75rem;
    margin-right: .5rem;
    display: inline-block;
    vertical-align: middle;
  }
  .contact-unit>div{
    word-wrap: break-word;
    display: inline-block;
    vertical-align: middle;
  }

  .contactUS{
    width: 100%;
    padding: 0 15% 2rem;
  }

  .contactUS-map{
    position: relative;
    max-height: 62.5rem;
    padding-top: 40%;
    /*background: url("../../static/images/home/contactUS-1.png") no-repeat center / cover;*/
    background: url("../../static/images/home/addres.png") no-repeat center / cover;
  }

  @media (max-width: 768px) {
    .contactUS-info{
      padding: 6rem 5%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/contactUS.vue